// FILE: src/pages/ManagerLogin.jsx
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * ManagerLogin
 * When a manager clicks "Login" for a specific account from ManagerSelect,
 * this route stores the selected accountId so the rest of the app knows
 * which account to open in read-only mode, then navigates into the app.
 *
 * Route: /manager/login/:accountId
 * Add in App.js:
 *   import ManagerLogin from "./pages/ManagerLogin";
 *   <Route path="/manager/login/:accountId" element={<ManagerLogin />} />
 */
export default function ManagerLogin() {
  const { accountId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (accountId) {
      try {
        localStorage.setItem("activeManagedAccountId", accountId);
        sessionStorage.setItem("activeManagedAccountId", accountId);
      } catch {}
      // If you have a dedicated read-only landing page, redirect to it instead of "/"
      navigate("/", { replace: true });
    } else {
      // No account id? Go back to the selector.
      navigate("/manager-select", { replace: true });
    }
  }, [accountId, navigate]);

  return null;
}
